import { Component, signal, inject, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { AuthService } from '../default/login/service/login-service/auth.service';
import { ConfigService } from '../../services/config.service';
import { ThemeMode } from '../../models/config.model';
import { ScrollbarComponent } from '../ui/scrollbar/scrollbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TranslationService } from '../../shared/services/translation.service';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterOutlet, DatePipe, ScrollbarComponent, SidebarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
  currentDate = new Date();
  sidebarOpen = signal(true);
  languageMenuOpen = signal(false);
  currentLanguage = signal<string>('en');
  private translationService = inject(TranslationService);

  constructor(
    public authService: AuthService,
    public configService: ConfigService
  ) {
    // Initialize current language
    this.currentLanguage.set(this.translationService.getCurrentLanguage());
  }

  toggleSidebar(): void {
    this.sidebarOpen.update(value => !value);
  }

  toggleDarkMode(): void {
    this.configService.toggleMode();
  }

  get currentMode(): ThemeMode {
    return this.configService.mode();
  }

  getLanguageName(lang: string): string {
    const names: { [key: string]: string } = {
      'en': 'English',
      'mr': 'मराठी',
      'hi': 'हिंदी'
    };
    return names[lang] || lang.toUpperCase();
  }

  toggleLanguageMenu(): void {
    this.languageMenuOpen.update(value => !value);
  }

  selectLanguage(lang: 'en' | 'mr' | 'hi'): void {
    this.translationService.setLanguage(lang);
    this.currentLanguage.set(lang);
    this.languageMenuOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.language-menu-container')) {
      this.languageMenuOpen.set(false);
    }
  }
}

